import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {CommonModule, CurrencyPipe, DecimalPipe} from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ARComponent } from './ar.component';
import { ARRoutingModule } from './ar-routing.module';
import { ArFeeCalculationComponent } from './fee-calculation/ar-fee-calculation/ar-fee-calculation.component';
import { ArLedgerComponent } from './ledger/ar-ledger/ar-ledger.component';
import { ArInsuranceClaimsComponent } from './ledger/ar-insurance-claims/ar-insurance-claims.component';
import { ArPaymentComponent } from './payment/ar-payment/ar-payment.component';
import { ArCreateTransactionComponent } from './fee-calculation/ar-create-transaction/ar-create-transaction.component';
import { ArDetailComponent } from './ar-detail/ar-detail.component';
import { ArCardPaymentComponent } from './payment/ar-card-payment/ar-card-payment.component';
import { ArPaymentInvoiceGeneratorComponent } from './payment/ar-payment-invoice-generator/ar-payment-invoice-generator.component';
import { ArDiscountComponent } from './ledger/ar-discount/ar-discount.component';
import { ClaimPredeterminationComponent } from './claims/claim-predetermination/claim-predetermination.component';
import { ClaimRealComponent } from './claims/claim-real/claim-real.component';
import { ClaimViewComponent } from './claims/claim-view/claim-view.component';
import { ClaimManagementComponent } from './claims/claim-management/claim-management.component';
import { ArInsurancePaymentComponent } from './payment/ar-insurance-payment/ar-insurance-payment.component';
import { ToothPickerModule } from '../tdo-shared/tooth-picker/tooth-picker.module';
import { ValidValueSelectModule } from '../../tdo-controls/validvalueselect/validvalueselect-module';
import { GeneralContextModule } from '../tdo-shared/general-context/general-context.module';
import { GeneralConfirmModule } from '../tdo-shared/general-confirm/general-confirm.module';
import { ClaimWizardComponent } from './claims/claim-wizard/claim-wizard.component';
import { PlanViewComponent } from './payment-plan/plan-view/plan-view.component';
import { PlanCreateComponent } from './payment-plan/plan-create/plan-create.component';
import { PlanListComponent } from './payment-plan/plan-list/plan-list.component';

import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import {MatRadioModule} from '@angular/material/radio';
import {TdoControlsModule} from '../../tdo-controls/tdo-controls.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatIconModule} from '@angular/material/icon';
import { ArLedgerNoteComponent } from './ledger/ar-ledger-note/ar-ledger-note.component';
import { ArPaymentCancelComponent } from './payment/ar-payment-cancel/ar-payment-cancel.component';
// import { ArPaymentAuditComponent } from './payment/ar-payment-audit/ar-payment-audit.component';
import { ClaimValidationDetailComponent } from './claims/claim-validation-detail/claim-validation-detail.component';
import { ArFeeCalculationErrorComponent } from './fee-calculation/ar-fee-calculation-error/ar-fee-calculation-error.component';
import { ClaimViewAttachmentsListComponent } from './claims/claim-view-attachments-list/claim-view-attachments-list.component';
import { ToothSurfacePickerComponent } from './fee-calculation/tooth-surface-picker/tooth-surface-picker.component';
import { ClaimLogComponent } from './claims/claim-log/claim-log.component';
import {MatTabsModule} from '@angular/material/tabs';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { ArPaymentRefundConfirmComponent } from './payment/ar-payment-refund-confirm/ar-payment-refund-confirm.component';
import { ArPaymentRefundAnyAmountConfirmComponent } from './payment/ar-payment-refund-any-amount-confirm/ar-payment-refund-any-amount-confirm.component';
import {DirectivesModule} from '../../directives/directives.module';
import { ArFeesListComponent } from './fee-calculation/ar-fees-list/ar-fees-list.component';
import {ConversionUtilities} from '../../utilities/conversion.utilities';
import { ArLedgerPaymentDistributionsComponent } from './ledger/ar-ledger-payment-distributions/ar-ledger-payment-distributions.component';
import { ArInsurancePaymentOverpayConfirmComponent } from './payment/ar-insurance-payment-overpay-confirm/ar-insurance-payment-overpay-confirm.component';
import { CreateAdjustment2Component } from './ledger/create-adjustment2/create-adjustment2.component';
import { ArLedgerItemSelectComponent } from './ledger/ar-ledger-item-select/ar-ledger-item-select.component';
import { ArLedgerProcedureDetailsComponent } from './ledger/ar-ledger-procedure-details/ar-ledger-procedure-details.component';
import { ArLedgerTableLayoutManagerComponent } from './ledger/ar-ledger-table-layout-manager/ar-ledger-table-layout-manager.component';
import { ArPaymentDetailsComponent } from './payment/ar-payment-details/ar-payment-details.component';
import { ArDebitCreditReasonsComponent } from './ledger/ar-debit-credit-reasons/ar-debit-credit-reasons.component';
import {MatBadgeModule} from '@angular/material/badge';
import { ArPaymentDeviceReceiptComponent } from './payment/ar-payment-device-receipt/ar-payment-device-receipt.component';
import { AccountingIntegrationComponent } from './accounting-integration/accounting-integration.component';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { TdoPaymentModule } from '@tdo-inc/tdo-payment';
import { ClaimStatusDxDialogComponent } from './claims/claim-status-dx-dialog/claim-status-dx-dialog.component';
import { ArInsurancePaymentProcessorTotalConfirmComponent } from './payment/ar-insurance-payment-processor-total-confirm/ar-insurance-payment-processor-total-confirm.component';
import { ArCardPaymentReceiptComponent } from './payment/ar-card-payment-receipt/ar-card-payment-receipt.component';
import { NarrativeNoteDialogComponent } from './claims/narrative-note-dialog/narrative-note-dialog.component';
import {ArPaymentTokenConsentComponent} from "./payment/ar-payment-token-consent/ar-payment-token-consent.component";
import { ClaimValidationDetailDxcParsedComponent } from './claims/claim-validation-detail-dxc-parsed/claim-validation-detail-dxc-parsed.component';
import {
    DxButtonModule,
    DxDropDownBoxModule,
    DxListModule,
    DxSelectBoxModule,
    DxTreeViewModule
} from "devextreme-angular";
import { ArPaymentDistributionsComponent } from './payment/ar-payment-distributions/ar-payment-distributions.component';
import { ArLedgerChargeVoidComponent } from './ledger/ar-ledger-void/ar-ledger-charge-void.component';

@NgModule({
    declarations: [
        ARComponent,
        ArFeeCalculationComponent,
        ArLedgerComponent,
        ArInsuranceClaimsComponent,
        ArPaymentComponent,
        ArCreateTransactionComponent,
        ArDetailComponent,
        ArCardPaymentComponent,
        ArPaymentInvoiceGeneratorComponent,
        ArDiscountComponent,
        ClaimPredeterminationComponent,
        ClaimRealComponent,
        ClaimViewComponent,
        ClaimManagementComponent,
        ArInsurancePaymentComponent,
        ClaimWizardComponent,
        PlanViewComponent,
        PlanCreateComponent,
        PlanListComponent,
        ArLedgerNoteComponent,
        ArPaymentCancelComponent,
        // ArPaymentAuditComponent,
        ClaimValidationDetailComponent,
        ArFeeCalculationErrorComponent,
        ClaimViewAttachmentsListComponent,
        ToothSurfacePickerComponent,
        ClaimLogComponent,
        ArPaymentRefundConfirmComponent,
        ArPaymentRefundAnyAmountConfirmComponent,
        ArFeesListComponent,
        ArLedgerPaymentDistributionsComponent,
        ArInsurancePaymentOverpayConfirmComponent,
        CreateAdjustment2Component,
        ArLedgerItemSelectComponent,
        ArLedgerProcedureDetailsComponent,
        ArLedgerTableLayoutManagerComponent,
        ArPaymentDetailsComponent,
        ArDebitCreditReasonsComponent,
        ArPaymentDeviceReceiptComponent,
        AccountingIntegrationComponent,
        ClaimStatusDxDialogComponent,
        ArInsurancePaymentProcessorTotalConfirmComponent,
        ArCardPaymentReceiptComponent,
        NarrativeNoteDialogComponent,
        ArPaymentTokenConsentComponent,
        ClaimValidationDetailDxcParsedComponent,
        ArPaymentDistributionsComponent,
        ArLedgerChargeVoidComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ARRoutingModule,
        ValidValueSelectModule,
        ToothPickerModule,
        GeneralContextModule,
        GeneralConfirmModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatInputModule,
        MatSelectModule,
        MatDialogModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatSnackBarModule,
        MatDividerModule,
        MatMenuModule,
        MatTableModule,
        MatSortModule,
        MatRadioModule,
        TdoControlsModule,
        MatTooltipModule,
        MatIconModule,
        MatTabsModule,
        MatSlideToggleModule,
        DirectivesModule,
        MatBadgeModule,
        MatButtonToggleModule,
        TdoPaymentModule,
        DxDropDownBoxModule,
        DxTreeViewModule,
        DxListModule,
        DxSelectBoxModule,
        DxButtonModule
    ],
    providers: [
        DecimalPipe,
        CurrencyPipe,
        ConversionUtilities
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ARModule { }
